import { Injectable } from '@angular/core';

/**
 * Service to coordinate invite acceptance flow and prevent race conditions
 * with onAuthStateChanged callbacks during registration.
 */
@Injectable({ providedIn: 'root' })
export class InviteFlowService {
  private isAcceptingInvite = false;

  startAcceptingInvite(): void {
    this.isAcceptingInvite = true;
  }

  finishAcceptingInvite(): void {
    this.isAcceptingInvite = false;
  }

  isInProgress(): boolean {
    return this.isAcceptingInvite;
  }
}
